<span
  [ngClass]="{ 'open-toggle': open }"
  class="rv-flex toggle"
  (click)="open = !open"
>
  <div class="rv-flex">
    <riv-icon *ngIf="icon" [name]="icon"></riv-icon>
    <header class="rv-title-02">{{ header }}</header>
  </div>
  <riv-icon *ngIf="open" [name]="'ChevronUp'"></riv-icon>
  <riv-icon *ngIf="!open" [name]="'ChevronDown'"></riv-icon>
</span>
<div *ngIf="open" class="content"><ng-content></ng-content></div>
